<div class="modal fade"
  tabindex="-1"
  [ngClass]="{'in': showModalVariable}"
  [ngStyle]="{'display': showModalVariable ? 'flex' : 'none'}"
  role="dialog"
  aria-labelledby="modalTitle"
  aria-hidden="true"
  (click)="hideModalClose()"
  (keyup)="hideModalClose()">

  <!-- Prevent click from bubbling up to modal container -->
  <div class="modal-dialog"
    style="width: 1200px;"
    (click)="$event.stopPropagation()">

    <div class="modal-content">
      <div class="modal-header"
        style="position: relative; padding: 15px;">
        <h3 class="modal-title">{{ title }}</h3>
        <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="hideModalClose()"
          style="position: absolute; top: 5px; right: 10px; font-size: 20px; cursor: pointer; border: none; background: none;">
          <i class="fa fa-times"
            aria-label="Close"></i>
        </button>
      </div>

      <div>
        <div class="border-top pb-4"></div>



        <div class="row"
          style="margin-bottom: -14px;">
          <div class="col-md-4"
            style="width: 18%; padding-left: 40px;">Request Date</div>
          <div class="col-md-8">
            <p class="fixed-height">{{ descDetails?.rqstDate }}</p>
          </div>
        </div>

        <div class="row"
          style="margin-bottom: -14px;">
          <div class="col-md-4"
            style="width: 18%; padding-left: 40px;">Sent On</div>
          <div class="col-md-8">
            <p class="fixed-height">{{ descDetails?.sentOnDate}}</p>
          </div>
        </div>

        <div class="row"
          style="margin-bottom: -14px;">
          <div class="col-md-4"
            style="width: 18%; padding-left: 40px;">To</div>
          <div class="col-md-8">
            <p class="fixed-height"
              [innerHTML]="descDetails?.emlTo"></p>

          </div>
        </div>

        <div class="row"
          style="margin-bottom: -14px;">
          <div class="col-md-4"
            style="width: 18%; padding-left: 40px;">Subject</div>
          <div class="col-md-8">
            <p class="fixed-height">{{ descDetails?.emlSubject }}</p>
          </div>
        </div>

        <div class="row"
          style="margin-bottom: -14px;">
          <div class="col-md-4"
            style="width: 18%; padding-left: 40px;">Message</div>
          <div class="col-md-8">
            <p class="fixed-height"
              [innerHTML]="safeHtml"
              (click)="handleClick($event)"
              style="line-height: 1; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
            </p>
          </div>
        </div>
      </div>

      <div class="modal-footer"
        style="padding: 10px; text-align: right;">
        <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
          #btnConfig
          class="btn-primary p-2"
          (click)="hideModalClose()">Close</button>
      </div>
    </div>
  </div>
</div>